import React, { createContext, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const SnackbarContext = createContext(null);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function SnackbarProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');

  const show = (newMessage = '', severity) => {
    setMessage(newMessage);
    setSeverity(severity);
    setOpen(true);
  };

  const success = (newMessage) => show(newMessage, 'success');
  const error = (newMessage) => show(newMessage, 'error');
  const warning = (newMessage) => show(newMessage, 'warning');
  const info = (newMessage) => show(newMessage, 'info');

  const hide = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <SnackbarContext.Provider
      value={{
        hide,
        success,
        error,
        warning,
        info,
      }}
    >
      {children}
      <Snackbar open={open} autoHideDuration={6000} onClose={hide}>
        <Alert onClose={hide} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}

export { SnackbarProvider };

export default SnackbarContext;
